import * as React from "react";

const Dots = () => (
	<span className="loader">
		<span className="loader__item" />
		<span className="loader__item" />
		<span className="loader__item" />
	</span>
);

export default Dots;
